import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-evidence-and-recommendations',
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule
  ],
  templateUrl: './evidence-and-recommendations.component.html',
  styleUrl: './evidence-and-recommendations.component.scss'
})
export class EvidenceAndRecommendationsComponent {
  @Input() evidenceSources: any[] = [];
  @Input() recommendations: any[] = [];
  @Input() evidenceTitle: string = 'Data Sources';
  @Input() recommendationsTitle: string = 'Improvement Recommendations';
  @Input() showEvidence: boolean = true;
  @Input() showRecommendations: boolean = true;

  getEvidenceTooltip(evidence: any): string {
    if (!evidence) return '';

    let tooltip = '';
    if (evidence.category) tooltip += `Category: ${evidence.category}\n`;
    if (evidence.confidence_score && typeof evidence.confidence_score === 'number') {
      tooltip += `Confidence: ${Math.round(evidence.confidence_score * 100)}%\n`;
    }
    if (evidence.snippet) tooltip += `Snippet: ${evidence.snippet}\n`;
    if (evidence.url) tooltip += `\nClick to view source`;

    return tooltip.trim();
  }

  openSourceLink(url: string): void {
    if (url && url.trim() !== '' && url !== '#') {
      // Open the link in a new tab
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      // Show a message if no URL is available
      // console.log('No source URL available for this item');
    }
  }
}
